<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <form *ngIf="signatureStatus" [formGroup]="signatureForm">
    <div class="row form-group d-flex justify-content-center">
      <label for="signature" class="col-lg-2 col-form-label my-3" style="font-size: medium;">ลายเซ็น</label>
      <div class="col-lg-10 my-3">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="signature" accept=".png, .jpg, .jpeg"
            (change)="onSignatureSelected($event, signatureForm)">
          <label class="custom-file-label" for="slip">{{ signature }}</label>
          <label *ngIf="!signature" class="custom-file-label" for="slip">Choose file</label>
          <label *ngIf="signature" class="custom-file-label" for="slip">{{ signature }}</label>
        </div>
        <span class="text-danger" style="font-size: smaller;">*ภาพขนาด 15cm x 7cm หรือ 566px x 264px เท่านั้น</span>
      </div>
      <label for="signature" class="col-lg-2 my-3 col-form-label" style="font-size: medium;">ชื่อ</label>
      <div class="col-lg-10 my-3">
        <input type="text" class="form-control" formControlName="name">
      </div>
      <label class="col-lg-2 my-3 col-form-label" style="font-size: medium;">ตำแหน่ง</label>
      <div class="col-lg-10 my-3">
        <input type="text" class="form-control" formControlName="title">
      </div>
    </div>
    <div class="row my-3">
      <div class="col d-flex justify-content-center">
        <img [src]="signaturePic" alt="" class="img-fluid mx-auto d-block" style="width: 250px;">
      </div>
    </div>
  </form>
</mat-dialog-content>

<div *ngIf="signatureStatus" align="center" style="padding-bottom: 20px; padding-top: 20px;">
  <button *ngIf="!signatureForm.valid" mat-button class="m-3" style="background: #c0c0c0; color: #fff;"
    [disabled]="true">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="signatureForm.valid" mat-button class="m-3" style="background: #3E8C1A; color: #fff;"
    (click)="confirm()">
    {{ modalData.actionBtnText }}
  </button>
  <button mat-button class="m-3" style="background: #c0c0c0; color: #fff;" (click)="closeModal()">
    {{ modalData.cancleBtnText }}
  </button>
</div>
